import { useSelector } from 'react-redux';
import NotificationsContent, {
  NotificationsActions,
} from '@widgets/sidebar/parts/NotificationsContent';

export default function NotificationsDrawer() {
  const { count_unread } = useSelector((state) => state.notifications);
  return (
    <>
      <NotificationsContent />
      {count_unread > 0 && (
        <div className="dialog-actions block-pd-x">
          <NotificationsActions />
        </div>
      )}
    </>
  );
}
